import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly STORAGE_KEY = 'currentUser';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!(req.url.includes('api.pusulatatil.com') || req.url.includes('/api/'))) {
      return next.handle(req);
    }

    try {
      const userStr = localStorage.getItem(this.STORAGE_KEY);
      if (userStr) {
        const user = JSON.parse(userStr);
        if (user?.token) {
          const authReq = req.clone({
            setHeaders: { Authorization: `Bearer ${user.token}` }
          });
          return next.handle(authReq);
        }
      }
    } catch {}

    return next.handle(req);
  }
}
